'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useCallback } from 'react';
import { useRefinementList } from 'react-instantsearch';
import ClearAllFiltersButton from 'components/consumer/ClearAllFiltersButton';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
const ClearAllFiltersButtonComponent = () => {
  const $ = _c(21);
  const {
    isReadyToShipActive,
    handleToggleReadyToShip,
    minWidth,
    maxWidth,
    handleWidthChange,
    selectedColors,
    clearSelectedColors,
    updateTypeFilter
  } = useAdvancedSearchContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      attribute: "type"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    items,
    refine
  } = useRefinementList(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      attribute: "option_color"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    items: colorItems,
    refine: refineColor
  } = useRefinementList(t1);
  let t2;
  if ($[2] !== items) {
    t2 = items?.some(_temp) || false;
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const hasActiveProductTypes = t2;
  const hasActiveWidth = !!(minWidth || maxWidth);
  let t3;
  if ($[4] !== colorItems || $[5] !== selectedColors) {
    t3 = colorItems?.some(_temp2) || Object.values(selectedColors || {}).some(Boolean);
    $[4] = colorItems;
    $[5] = selectedColors;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const hasActiveColors = t3;
  const hasActiveFilters = isReadyToShipActive || hasActiveWidth || hasActiveProductTypes || hasActiveColors;
  let t4;
  if ($[7] !== clearSelectedColors || $[8] !== colorItems || $[9] !== handleToggleReadyToShip || $[10] !== handleWidthChange || $[11] !== hasActiveColors || $[12] !== hasActiveProductTypes || $[13] !== hasActiveWidth || $[14] !== isReadyToShipActive || $[15] !== refine || $[16] !== refineColor || $[17] !== updateTypeFilter) {
    t4 = () => {
      if (isReadyToShipActive) {
        handleToggleReadyToShip?.(false);
      }
      if (hasActiveWidth) {
        handleWidthChange?.("", "");
      }
      if (hasActiveProductTypes) {
        refine([]);
        updateTypeFilter?.(null);
      }
      if (hasActiveColors) {
        colorItems?.filter(_temp3).forEach(item_2 => refineColor(item_2.label));
        clearSelectedColors?.();
      }
    };
    $[7] = clearSelectedColors;
    $[8] = colorItems;
    $[9] = handleToggleReadyToShip;
    $[10] = handleWidthChange;
    $[11] = hasActiveColors;
    $[12] = hasActiveProductTypes;
    $[13] = hasActiveWidth;
    $[14] = isReadyToShipActive;
    $[15] = refine;
    $[16] = refineColor;
    $[17] = updateTypeFilter;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const handleClearAll = t4;
  if (!hasActiveFilters) {
    return null;
  }
  let t5;
  if ($[19] !== handleClearAll) {
    t5 = <div className="md:pb-5"><ClearAllFiltersButton onClick={handleClearAll}>Clear all</ClearAllFiltersButton></div>;
    $[19] = handleClearAll;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
export default ClearAllFiltersButtonComponent;
function _temp(item) {
  return item.isRefined;
}
function _temp2(item_0) {
  return item_0.isRefined;
}
function _temp3(item_1) {
  return item_1.isRefined;
}